import { useEffect } from "react";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/choosePin";
import {
  ChoosePinChannel,
  choosePinSelectGaEvent,
  trackChoosePinSelect,
  trackChoosePinView,
} from "@/analytics/choosePin";

type ChannelType = "email" | "phone" | "whatsapp";

type ChannelRow = {
  type: ChannelType;
  show: boolean;
  label: string;
  description: string;
  iconSrc: string;
  iconAlt: string;
  chooseLabel: string;
};

export default function ChoosePin({
  goBack,
  goToPin,
  showSms,
  showWhatsApp,
  showEmail,
  isLoadingFlags = false,
}: PropsView) {
  useEffect(() => {
    trackChoosePinView();
  }, []);

  const handleChoose = (type: ChoosePinChannel) => {
    trackChoosePinSelect(type);
    goToPin(type);
  };

  const channels: ChannelRow[] = [
    {
      type: "whatsapp",
      show: showWhatsApp,
      label: "WhatsApp",
      description: "Receber código no celular informado",
      iconSrc: "/svg/icon-whatsapp-primary-2.0.svg",
      iconAlt: "WhatsApp",
      chooseLabel: "Escolher WhatsApp",
    },
    {
      type: "email",
      show: showEmail,
      label: "E-mail",
      description: "Receber código no e-mail informado",
      iconSrc: "/svg/icon-mail-2.0.svg",
      iconAlt: "E-mail",
      chooseLabel: "Escolher e-mail",
    },
    {
      type: "phone",
      show: showSms,
      label: "SMS",
      description: "Receber código no celular informado",
      iconSrc: "/svg/icon-sms-2.0.svg",
      iconAlt: "SMS",
      chooseLabel: "Escolher SMS",
    },
  ];

  const visible = channels.filter((c) => c.show);

  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header title="Dados pessoais" hasLeftButton goBack={goBack} />
      <main className="flex-1 w-full flex justify-center min-h-0 bg-background">
        <article className="w-full max-w-[480px] px-6 pt-6 pb-8">
          <h2 className="text-text text-[22px] leading-tight font-primary tracking-tight">
            Valide seus dados
          </h2>
          <p className="mt-3 font-primary text-base text-tertiary leading-relaxed">
            Escolha o canal para receber o código e validar o acesso:
          </p>

          {!isLoadingFlags && visible.length > 0 && (
            <div
              className="mt-8 border-t border-border divide-y divide-border"
              role="list"
            >
              {visible.map((row) => (
                <button
                  key={row.type}
                  type="button"
                  role="listitem"
                  id={`choose-pin-channel-${row.type}`}
                  data-ga-event={choosePinSelectGaEvent(row.type)}
                  onClick={() => handleChoose(row.type)}
                  className="w-full flex items-center gap-3 py-4 text-left min-h-[56px] active:opacity-80"
                >
                  <div
                    className="shrink-0 w-12 h-12 rounded-lg flex items-center justify-center bg-gray-100"
                    aria-hidden
                  >
                    <img
                      src={row.iconSrc}
                      width={22}
                      height={22}
                      alt=""
                      className="w-[22px] h-[22px]"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-base font-semibold text-text">
                      {row.label}
                    </p>
                    <p className="text-sm text-text-secondary mt-0.5 leading-snug">
                      {row.description}
                    </p>
                  </div>
                  <img
                    src="/svg/icon-arrow-right-2.0.svg"
                    width={9}
                    height={16}
                    alt={row.chooseLabel}
                    className="shrink-0 w-2 h-4"
                  />
                </button>
              ))}
            </div>
          )}
        </article>
      </main>
    </div>
  );
}
